import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from 'react-redux';
import DOMPurify from 'dompurify';
import { Panel } from "primereact/panel"
import { Ripple } from "primereact/ripple"

import "../index.css"

import { Button } from "../../../helpers"
import Loading from "../../../common/Loading"
import SendEmail from "../../../common/SendEmail";

import TrackingDetails from "./TrackingDetails"
import DeliveryDetails from "./DeliveryDetails"

import { updateDeliveryChallan } from "../../../services/api/deliveryChallan"
import { updateDispatchNote } from "../../../services/api/dispatchNote"
import { getDocCopyByDocNo } from "../../../services/api/docCopy";
import { raiseToast } from "../../../services/redux/reducers/toast/toast"
import { getUserById } from "../../../services/api/user";

import { validateInputs, getFullName, checkPermissions } from "../../../utils";

import { DeliveryDetailsValidation } from "../../../validation/deliveryDetailsValidation";
import { DispatchTrackingDetailsValidation } from "../../../validation/dispatchTrackingDetailsValidation";


const DispatchNote = (props) => {

    const dispatch = useDispatch()

    let { dispatchNote, dispatchNoteItems, logisticPartners, statesList, buyerInvoices, invoiceDispatchMap, handleDeleteDispatchNote } = props

    const [isLoading, setIsLoading] = useState(false)
    const [previousDeliveryChallan, setPreviousDeliveryChallan] = useState({})
    const [previousTrackingDetails, setPreviousTrackingDetails] = useState({})
    const [editedDeliveryChallan, setEditedDeliveryChallan] = useState({})
    const [editedTrackingDetails, setEditedTrackingDetails] = useState({})
    const [deliveryChallanUpdatedUser, setDeliveryChallanUpdatedUser] = useState({})

    const [trackingDetailsFormErrors, setTrackingDetailsFormErrors] = useState({})
    const [deliveryChallanFormErrors, setDeliveryChallanFormErrors] = useState({})

    const [emailDetailsObj, setEmailDetailsObj] = useState({})
    const [isEmailDialogVisible, setIsEmailDialogVisible] = useState(false)

    const userNameDetails = useSelector(state => state.userDetails.userNameDetails)
    const userDetails = useSelector(state => state.userDetails)

    useEffect(()=>{
        if(props.dispatchNote && props.dispatchNote?.deliveryChallan){
            setEditedDeliveryChallan({...props.dispatchNote?.deliveryChallan})
            setPreviousDeliveryChallan({...props.dispatchNote?.deliveryChallan})
        }
        if(props.dispatchNote){
            setEditedTrackingDetails({...props.dispatchNote})
            setPreviousTrackingDetails({...props.dispatchNote})
        }
    },[])

    useEffect(() => {   
        getDeliveryChallanCreatedUser()
    }, [previousDeliveryChallan])

    const getDeliveryChallanCreatedUser = async () => {
        let userId = previousDeliveryChallan?.updatedBy
        const userRes = await getUserById(userId)
        if (userRes?.failure){

        }else{
            setDeliveryChallanUpdatedUser(userRes?.data[0])
        }
    }
    const onUpdateDeliveryDetails = async () => {
        if (!editedDeliveryChallan.docProof) {
            return dispatch(raiseToast({ severity: 'warn', detail: "Please upload POD document", life: 3000 }))
        }

        const deliveryDetailsValidation = await validateInputs(DeliveryDetailsValidation, editedDeliveryChallan)
        
        if (deliveryDetailsValidation) {
            if (deliveryDetailsValidation.error) {
                if (deliveryDetailsValidation.error) {
                    setDeliveryChallanFormErrors(deliveryDetailsValidation.error)
                    Object.keys(deliveryDetailsValidation.error).map(eachError => {
                        dispatch(raiseToast({ severity: 'warn', detail: deliveryDetailsValidation.error[eachError], life: 3000 }))
                    })
                }
            }
            else {
                setDeliveryChallanFormErrors({})
                
                let updateDeliveryDelivery = {...deliveryDetailsValidation.result}
                setEditedDeliveryChallan(updateDeliveryDelivery)

                if (window.confirm("Are you sure you want to update delivery details")) {
                    if (JSON.stringify(updateDeliveryDelivery) !== JSON.stringify(dispatchNote?.deliveryChallan)) {
                        setIsLoading(true)
                        let updatedDeliveryChallanResponse = await updateDeliveryChallan(editedDeliveryChallan.deliveryChallanId, editedDeliveryChallan)
                        // console.log("updatedDeliveryChallan-response", updatedDeliveryChallanResponse)
                        if (updatedDeliveryChallanResponse.failure) {
                            setIsLoading(false)
                            return dispatch(raiseToast({ severity: 'error', detail: updatedDeliveryChallanResponse.data.error, life: 3000 }))
                        } else {
                            setIsLoading(false)
                            if(updatedDeliveryChallanResponse?.data[1][0]){
                                setEditedDeliveryChallan({...updatedDeliveryChallanResponse?.data[1][0]})
                                setPreviousDeliveryChallan({...updatedDeliveryChallanResponse?.data[1][0]})
                            }
                            dispatch(raiseToast({ severity: 'success', detail: "Delivery details updated successfully", life: 3000 }))
                        }
                    }
                }
            }
        }
    }

    const handleUpdateTrackingDetails = async (triggerSendMail) => {
        if (!editedTrackingDetails.trackingDocPath) {
            return dispatch(raiseToast({ severity: 'warn', detail: "Please upload tracking document", life: 3000 }))
        }

        const trackingDetailsValidation = await validateInputs(DispatchTrackingDetailsValidation, editedTrackingDetails)
        const relatedInvoiceDispatchMap = invoiceDispatchMap.find(eachInvoiceDispatchMap => eachInvoiceDispatchMap.dispatchNoteId === dispatchNote.dispatchNoteId)
        const relatedInvoice = buyerInvoices.find(eachBuyerInvoice => eachBuyerInvoice.buyerInvoiceId === relatedInvoiceDispatchMap?.buyerInvoiceId)
        
        let relatedInvoiceDocCopy = null
        let relatedInvoiceDocumentRes = null
        if(relatedInvoice && relatedInvoice.docNo){
            relatedInvoiceDocumentRes = await getDocCopyByDocNo(relatedInvoice.docNo, false, false)
        }
        
        if(relatedInvoiceDocumentRes){
            relatedInvoiceDocCopy = relatedInvoiceDocumentRes.docLocation
        }

        let attachments = []
        if(relatedInvoiceDocCopy){
            attachments.push({file_name: `${relatedInvoice.docNo}.pdf`, url: relatedInvoiceDocCopy})
        }
        
        if (trackingDetailsValidation) {
            if (trackingDetailsValidation.error) {
                if (trackingDetailsValidation.error) {
                    setTrackingDetailsFormErrors(trackingDetailsValidation.error)
                    Object.keys(trackingDetailsValidation.error).map(eachError => {
                        dispatch(raiseToast({ severity: 'warn', detail: trackingDetailsValidation.error[eachError] }))
                    })
                }
            }
            else {
                setTrackingDetailsFormErrors({})

                let updateTrackingDetails = {...trackingDetailsValidation.result}
                setEditedTrackingDetails(updateTrackingDetails)

                if(triggerSendMail && relatedInvoice){
                    const relatedPartner = logisticPartners.find(eachPartner => eachPartner.logisticPartnerId === editedTrackingDetails.logisticPartnerId)
                    let htmlString = `
                        <div style="font-family: Arial, sans-serif; line-height: 1.5;">
                            <img src="https://procmart-dev.s3.ap-south-1.amazonaws.com/logo.png" alt="ProcMart Logo" style="margin-bottom: 20px;">
                            <p>Dear ${getFullName(relatedInvoice.buyerUserName.firstName, relatedInvoice.buyerUserName.lastName)},</br>
                            We are pleased to inform you that your order has been dispatched. Below are the tracking details for your reference:</p>
                            <ul>
                                <li><strong>Logistic Partner:</strong> ${relatedPartner.partnerName}</li>
                                <li><strong>Tracking Number:</strong> ${updateTrackingDetails.trackingNumber}</li>
                                <li><strong>Tracking Link:</strong> <a href="${updateTrackingDetails.trackingOrderLink}">Track your order</a></li>
                                <li><strong>Expected Delivery Date:</strong> ${updateTrackingDetails.expectedDeliveryDate}</li>
                            </ul>
                            ${relatedInvoiceDocCopy ? '<p>Please find the attached invoice for your order for your reference.</p>' : ''}
                            <p><b>Client PO Num:</b> ${relatedInvoice.buyerPONumbers} , <b>Invoice No:</b> ${relatedInvoice.docNo}</p>
                            <p>If you have any questions or require assistance, please don't hesitate to contact us at the details provided below.</p>
                            <p>Best regards,</br>   
                            ${getFullName(userNameDetails.firstName, userNameDetails.lastName)},</br>
                            ${userNameDetails.emailId},</br>
                            ${userNameDetails.phoneNumber}.
                            </p>
                        </div>
                    `;
                    let sanitizedHTML = DOMPurify.sanitize(htmlString)
                    const emailDetailObj = {
                        to: relatedInvoice.buyerUserName.emailId,
                        from: userNameDetails.emailId,
                        kam: userNameDetails.emailId,
                        subject: `Tracking Details Updated for Order - ${relatedInvoice?.docNo}`,
                        message: sanitizedHTML,
                        attachments: attachments,
                        cc: []
                    }
                    setEmailDetailsObj(emailDetailObj)
                    setIsEmailDialogVisible(true)
                }
                else{
                    updateDispatchNoteDetails()
                }
            }
        }
    }

    const updateDispatchNoteDetails = async (emailObj) => {
        if (window.confirm("Are you sure you want to update tracking details")) {
            let trackingDetailsUpdatedObj = {
                logisticPartnerId: editedTrackingDetails.logisticPartnerId,
                trackingNumber: editedTrackingDetails.trackingNumber,
                trackingOrderLink: editedTrackingDetails.trackingOrderLink,
                trackingDocPath: editedTrackingDetails.trackingDocPath,
                expectedDeliveryDate: editedTrackingDetails.expectedDeliveryDate,
            }
            if (JSON.stringify(editedTrackingDetails) !== JSON.stringify(dispatchNote)) {
                setIsLoading(true)
                let updatedTrackingDetailsResponse = await updateDispatchNote(editedTrackingDetails.dispatchNoteId, {...trackingDetailsUpdatedObj, emailObj: emailObj })
                if (updatedTrackingDetailsResponse.failure) {
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'error', detail: updatedTrackingDetailsResponse.data.error, life: 3000 }))
                } else {
                    setIsLoading(false)
                    if(updatedTrackingDetailsResponse?.data[1][0]){
                        setEditedTrackingDetails({...updatedTrackingDetailsResponse?.data[1][0]})
                        setPreviousTrackingDetails({...updatedTrackingDetailsResponse?.data[1][0]})
                    }
                    dispatch(raiseToast({ severity: 'success', detail: "Tracking details updated successfully", life: 3000 }))
                }
            }
        }
    }

    const cancelDispatchNote = (dispatchNoteId) => {
        if(window.confirm("Confirm to delete dispatch note")){
            handleDeleteDispatchNote(dispatchNoteId)
        }
    }
    
    const dispatchNoteTemplate = (options) => {
        const toggleIcon = !options.collapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-right';
        const className = `${options.className} justify-content-between`;
        const titleClassName = `${options.titleClassName} ml-2 text-primary`;
        const style = { fontSize: '1.25rem' };

        const relatedInvoiceDispatchMap = invoiceDispatchMap?.find(eachInvoiceDispatchMap => eachInvoiceDispatchMap?.dispatchNoteId === dispatchNote?.dispatchNoteId)
        const relatedInvoice = buyerInvoices?.find(eachBuyerInvoice => eachBuyerInvoice?.buyerInvoiceId === relatedInvoiceDispatchMap?.buyerInvoiceId && eachBuyerInvoice.statusId === 1)

        return (
            <div className={className} style={{ display: "flex", padding: "3px 10px", justifyContent: "", fontFamily: "Amazon Ember,Arial,sans-serif" }}>
                <button className={options.togglerClassName} onClick={options.onTogglerClick}>
                    <span className={toggleIcon}></span>
                    <Ripple />
                </button>
                <div className="flex flex-row justify-content-start ml-3" style={{ flex: 1, justifyContent: "flex-start", alignItems: "center" }}>
                    <div className="flex flex-column ml-3">
                        <p className="m-0"><span style={{ fontWeight: 700 }}>{previousDeliveryChallan.docNo && `Delivery Challan: ${previousDeliveryChallan.docNo} | `} {relatedInvoice?.docNo && `Invoice: ${relatedInvoice?.docNo} | `} {dispatchNote?.docNo && `Dispatch Note: ${dispatchNote?.docNo}`}</span></p>
                    </div>
                </div>
                {
                    relatedInvoice ? 
                        <i className="pi pi-trash" style={{ fontSize: '1rem', cursor: "not-allowed", color: "grey" }} ></i>
                    : 
                        <i className="pi pi-trash" style={{ fontSize: '1rem', cursor: "pointer", color: "red" }} onClick={() => {cancelDispatchNote(dispatchNote.dispatchNoteId)}} ></i>
                }
            </div>
        )
    }

    const handleEditDeliveryDetails = () => {
        setEditedDeliveryChallan(prevState => ({...prevState, isEditable: true}))
    }

    const handleDiscardDeliveryDetails = () => {
        if (window.confirm("Do you want to discard the changes..?")){
            let updatedDeliveryChallan = {...previousDeliveryChallan, isEditable: false}
            setEditedDeliveryChallan(updatedDeliveryChallan)
        }
    }

    const handleEditTrackingDetails = () => {
        setEditedTrackingDetails(prevState => ({...prevState, isEditable: true}))
    }

    const handleDiscardTrackingDetails = () => {
        if (window.confirm("Do you want to discard the changes..?")){
            let updatedTrackingDetails = {...previousTrackingDetails, isEditable: false}
            setEditedTrackingDetails(updatedTrackingDetails)
        }
    }

    const relatedInvoiceDispatchMap = invoiceDispatchMap?.find(eachInvoiceDispatchMap => eachInvoiceDispatchMap?.dispatchNoteId === dispatchNote?.dispatchNoteId)
    const relatedInvoice = buyerInvoices?.find(eachBuyerInvoice => eachBuyerInvoice?.buyerInvoiceId === relatedInvoiceDispatchMap?.buyerInvoiceId)

    const docProofAlreadyExists = previousDeliveryChallan?.docProof ? true : false
    const trackingDocAlreadyExists = previousTrackingDetails.trackingDocPath ? true : false

    let {isPermitted: editTrackingPermitted} = checkPermissions({ ...userDetails, permissions: [202] })
    let {isPermitted: editDeliveryDetailsPermitted} = checkPermissions({ ...userDetails, permissions: [201] })

    return (
        <Panel className="mb-2" id={dispatchNote?.dispatchNoteId} style={{ padding: "0px" }} headerTemplate={dispatchNoteTemplate} toggleable>
            <div className="dispatch-note-list">
                <div className="custom-table-container">
                    <table className="custom-product-table" style={{ width: "100%" }}>
                        <thead >
                            <tr className="">
                                <th className="" style={{ width: "5%" }}>SR</th>
                                <th className="" style={{ width: "15%" }}>MATERIAL ID</th>
                                <th className="" style={{ width: "35%" }}>PRODUCT</th>
                                <th className="" style={{ width: "50%" }}>SPECIFICATION</th>
                                <th className="" style={{ width: "10%" }} >QUANTITY</th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                            {
                                dispatchNoteItems?.map((eachDispatchItem, index) => {
                                    let productName = eachDispatchItem?.companyProdName ? eachDispatchItem?.companyProdName : eachDispatchItem?.productName
                                    let productSpecification = eachDispatchItem?.companyProdSpec ? eachDispatchItem?.companyProdSpec : eachDispatchItem?.productSpecification
                                    return (
                                        <tr className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                            <td className="">{index + 1}</td>
                                            <td className="">{eachDispatchItem?.materialId}</td>
                                            <td className="">{productName}</td>
                                            <td className="">{productSpecification}</td>
                                            <td className="">{eachDispatchItem?.qty}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            
            <div className="mt-3">
                <TrackingDetails
                    dispatchNote={dispatchNote}
                    previousTrackingDetails={previousTrackingDetails}
                    logisticPartners={logisticPartners}
                    editedTrackingDetails={editedTrackingDetails}
                    setEditedTrackingDetails={setEditedTrackingDetails}
                    statesList={statesList}
                    trackingDetailsFormErrors={trackingDetailsFormErrors}
                />
                {
                    trackingDocAlreadyExists && !editedTrackingDetails.isEditable ? 
                        <div className='flex justify-content-end flex-row'>
                            <Button className="small-btn" label="Edit Tracking Details" onClick={handleEditTrackingDetails} disabled={!editTrackingPermitted} />
                        </div>
                        :
                        <div className='flex justify-content-end flex-row'>
                            {
                                trackingDocAlreadyExists && editedTrackingDetails.isEditable ? 
                                    <Button className="small-btn discard-btn" label="Discard Tracking Details" onClick={handleDiscardTrackingDetails} />
                                    : null
                            }
                            { relatedInvoice && <Button className="small-btn ml-2" label="Update Tracking Details And Send Mail" onClick={() => handleUpdateTrackingDetails(true)} /> }
                            <Button className="small-btn ml-2" label="Update Only Tracking Details" onClick={() => handleUpdateTrackingDetails(false)} />
                        </div>
                }
            </div>
            
            <div className="hr-line"></div>

            <div className="mt-3">
                <DeliveryDetails 
                    dispatchNote={dispatchNote}
                    previousDeliveryChallan={previousDeliveryChallan}
                    editedDeliveryChallan={editedDeliveryChallan}
                    setEditedDeliveryChallan={setEditedDeliveryChallan}
                    deliveryChallanFormErrors={deliveryChallanFormErrors}
                    buyerInvoice={relatedInvoice}
                    deliveryChallanUpdatedUser={deliveryChallanUpdatedUser}
                />
                {
                    docProofAlreadyExists ? 
                        (
                            editedDeliveryChallan?.isEditable ? 
                            <div className="flex flex-row justify-content-end">
                                <div className='flex justify-content-end flex-row mr-2'>
                                    <Button className="small-btn discard-btn" label="Discard Delivery Details" onClick={handleDiscardDeliveryDetails} />
                                </div> 
                                <div className='flex justify-content-end flex-row'>
                                    <Button className="small-btn save-btn" style={{fontSize: "12px", border : 0, backgroundColor: "purple"}} label="Save Delivery Details" onClick={onUpdateDeliveryDetails} />
                                </div> 
                            </div> 
                            :
                            <div className='flex justify-content-end flex-row'>
                                <Button className="small-btn" label="Edit Delivery Details" onClick={handleEditDeliveryDetails} disabled={!editDeliveryDetailsPermitted} />
                            </div> 
                        )
                    : 
                    <div className='flex justify-content-end flex-row'>
                        <Button className="small-btn" label="Update Delivery Details" onClick={onUpdateDeliveryDetails} />
                    </div>
                }
            </div>
            <SendEmail emailDetailsObj={emailDetailsObj} visible={isEmailDialogVisible} handleSendMail={updateDispatchNoteDetails} setEmailDetailsObj={setEmailDetailsObj} onHide={() => setIsEmailDialogVisible(false)}/>
            <Loading visible={isLoading} />
        </Panel>
    )
}

export default DispatchNote